module.exports = __webpack_public_path__ + "img/onlineshop@2x.1a3740c0.png";